import React from 'react'
import { hotkeys } from 'react-keyboard-shortcuts'

const handleEvent = (e, callback) => {
  if (e.preventDefault) {
    e.preventDefault()
  } else {
    // internet explorer
    e.returnValue = false
  }
  callback()
}

class SearchHOC extends React.PureComponent {
  hot_keys = {
    escape: {
      priority: 1,
      handler: e => handleEvent(e, this.props.onCancel)
    },
    'meta+p': {
      priority: 1,
      handler: e => handleEvent(e, this.props.onSearch)
    },
    'ctrl+p': {
      priority: 1,
      handler: e => handleEvent(e, this.props.onSearch)
    }
  }

  render() {
    return this.props.children
  }
}

export default hotkeys(SearchHOC)
